import { render, staticRenderFns } from "./logRecording.vue?vue&type=template&id=958bb060&scoped=true"
import script from "./logRecording.vue?vue&type=script&lang=js"
export * from "./logRecording.vue?vue&type=script&lang=js"
import style0 from "./logRecording.vue?vue&type=style&index=0&id=958bb060&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958bb060",
  null
  
)

export default component.exports